import { combineReducers } from '@reduxjs/toolkit';

import { clientSignupsApi } from '~direct-debits/actions/clientSignups';
import { connectionsApi } from '~direct-debits/actions/connections';
import { mandatesApi } from '~direct-debits/actions/mandates';
import { oauthApi } from '~direct-debits/actions/oauth';
import { paymentBatchesApi } from '~direct-debits/actions/paymentBatches';
import { signupsApi } from '~direct-debits/actions/signups';

// No slice reducers in this feature yet — placeholder keeps combineReducers valid
const placeholder = (state = {}) => state;
export default combineReducers({ placeholder });

export const directDebitsApis = [
  connectionsApi,
  oauthApi,
  clientSignupsApi,
  signupsApi,
  mandatesApi,
  paymentBatchesApi,
] as const;
